import {
  Component,
  Input,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ConsoleService } from 'src/app/core/services/console.service';
import {
  GroupPriceByOrganizationIdDto,
  GroupPriceDetailDto,
  GroupPriceSocialMediaByGroupPriceIdDto,
  UpdateGroupPriceDetailCommand,
  UpdateGroupPriceSocialMediaDetailsCommand,
} from '../../../../core/api/models';
import { SmsAggregator } from '../../../../core/api/models/sms-aggregator';
import { SmsLanguage } from '../../../../core/api/models/sms-language';
import { GroupPriceSocialMediaDetailsService } from '../../../../core/api/services';
import { EventTypes } from '../../../../core/constants/event-types';
import { KeyValueModel } from '../../../../core/models/key-value.model';
import { UtilityService } from '../../../../core/services/utility.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import {
  DialogService,
  DialogStatus,
} from './../../../../core/services/dialog.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SmsAggregatorBgColor } from '../shared/directives/sms-aggregator-background-color.directive';
import { SmsAggregatorImage } from '../shared/directives/sms-aggregator-image.directive';
import { SmsAggregatorImageWidth } from '../shared/directives/sms-aggregator-image-width.directive';


//compress text method
declare function compressToEncodedURIComponent(input): any;
declare function decompressFromEncodedURIComponent(input): any;

export interface SocialMediaSizeRange {
  beginningOfSize?: number;
  endOfSize?: any;
  priceList?: {
    smsAggregator?: SmsAggregator;
    price?: number;
  }[];
}

@Component({
    selector: 'app-group-price-social-media-detail-form',
    templateUrl: './group-price-social-media-detail-form.component.html',
    styleUrls: ['./group-price-social-media-detail-form.component.scss'],
    imports: [BaseFormModule, SmsAggregatorBgColor, SmsAggregatorImage, SmsAggregatorImageWidth]
})
export class GroupPriceSocialMediaDetailFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = 'pages.groupPrice.detailForm.';

  @Input() formPageConfig: FormPageConfig<
    GroupPriceSocialMediaByGroupPriceIdDto[]
  >;
  @Input() groupPrices: GroupPriceByOrganizationIdDto = {};
  @Input() groupPriceDetail: GroupPriceSocialMediaByGroupPriceIdDto[] = [];
  @Input() readOnly: boolean = false;
  @Input() showPageHeader: boolean = true;
  @Input() tagName: string;

  model: UpdateGroupPriceSocialMediaDetailsCommand = {};
  sizeRanges: SocialMediaSizeRange[] = [];

  kiloByteValue: number = 1024;
  megaByteValue: number = 1;
  //#region enums
  SmsLanguageValues = this.utilityService.enumValuesToArray(SmsLanguage);
  SmsAggregatorValues: KeyValueModel[] =
    this.utilityService.enumToObject(SmsAggregator);
  //#endregion

  //#endregion

  constructor(
    protected currentService: GroupPriceSocialMediaDetailsService,
    protected utilityService: UtilityService,
    protected dialogService: DialogService,
    protected renderer: Renderer2
  ) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.loading = false;
    this.title = this.pageVocabs + 'legend';
  }

  ngAfterViewInit(): void {
    this.initModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(this.groupPrices).length != 0) {
      if (Object.keys(this.groupPrices.details).length)
        this.setGroupPriceDetail(this.groupPrices.details);
    }
    //for myGroupPriceDetail and organizationGroupPriceDetail
    else if (
      this.groupPriceDetail != null &&
      this.groupPriceDetail != undefined &&
      Object.keys(this.groupPriceDetail).length
    )
      this.setGroupPriceDetail(this.groupPriceDetail);
  }

  //#region init methods

  initModel() {
    this.onAddSizeRange(0, 0);

    if (this.formPageConfig.editData?.length > 0)
      this.setGroupPriceDetail(this.formPageConfig.editData);
  }

  initForm() {
    this.form = new FormGroup({
      groupPriceId: new FormControl(''),
      kilobyte: new FormControl(''),
      megabyte: new FormControl(''),
    });
  }

  //#endregion

  //#region size ranges Crud

  onAddSizeRange(beginningOfSize?: number, endOfSize?: any) {
    let smsAggregators: number[] = this.SmsAggregatorValues.filter(
      (item) => +item.value != 0
    ).map((item) => +item.value);

    const newSizeRange: SocialMediaSizeRange = {};
    newSizeRange.priceList = smsAggregators.map((smsAggregator) => ({
      smsAggregator,
      price: null,
    }));

    if (beginningOfSize || beginningOfSize == 0)
      newSizeRange.beginningOfSize = beginningOfSize;

    if (endOfSize == -1) newSizeRange.endOfSize = '∞';
    else if (endOfSize) {
      newSizeRange.endOfSize = endOfSize;
    }

    this.sizeRanges.push(newSizeRange);
  }

  onRemoveSizeRange(index) {
    if (index < this.sizeRanges?.length) this.sizeRanges.splice(index, 1);
  }

  onUpdateSizeRange(beginningInput, endInput, index) {
    const beginningOfSize = +(beginningInput as HTMLInputElement)?.value;
    const endOfSize = +(endInput as HTMLInputElement)?.value;

    if (beginningOfSize > endOfSize) {
      //if (!beginningOfSize || !endOfSize) return;
      this.addInputError(beginningInput, endInput);
    } else {
      this.removeInputError(beginningInput, endInput);
    }
    if (beginningOfSize >= 0)
      this.sizeRanges[index].beginningOfSize = beginningOfSize;
    if (endOfSize >= 0) this.sizeRanges[index].endOfSize = endOfSize;
  }

  //#endregion

  //#region groupPriceDetail model

  getGroupPriceDetail(): GroupPriceDetailDto[] {
    try {
      const inputs: Element[] = this.getInputs();

      let model = inputs.map((item: Element) => {
        ConsoleService.info(
          'endofsize',
          (<HTMLInputElement>item).dataset.endofsize
        );

        return {
          price: +(<HTMLInputElement>item).value,
          smsAggregator: +(<HTMLInputElement>item).dataset.aggregator,
          beginningOfSizePerKilobyte: +(<HTMLInputElement>item).dataset
            .beginningofsize,
          endOfSizePerKilobyte:
            (<HTMLInputElement>item).dataset.endofsize == '∞'
              ? -1
              : +(<HTMLInputElement>item).dataset.endofsize,
        };
      });

      return model;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  setGroupPriceDetail(model: GroupPriceSocialMediaByGroupPriceIdDto[]) {
    try {
      if (model.length) this.sizeRanges = [];
      model.forEach((item) => {
        let sizeRange = this.sizeRanges.find(
          (range) => range.beginningOfSize == item.beginningOfSizePerKilobyte
        );
        //add
        if (!sizeRange) {
          this.onAddSizeRange(
            item.beginningOfSizePerKilobyte,
            item.endOfSizePerKilobyte
          );
          sizeRange = this.sizeRanges.find(
            (range) => range.beginningOfSize == item.beginningOfSizePerKilobyte
          );
        }
        // update
        sizeRange.priceList = sizeRange?.priceList.map((priceItem) =>
          priceItem.smsAggregator == item.smsAggregator
            ? { smsAggregator: item.smsAggregator, price: item.price || null }
            : priceItem
        );
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion

  //#region table inputs

  getInputs(): Element[] {
    try {
      const inputElements: NodeListOf<Element> = document.querySelectorAll(
        `${this.tagName} .input-item`
      );
      return Array.from(inputElements);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  isEmptyInputs(): boolean {
    try {
      const inputs: Element[] = this.getInputs();
      let isValid: boolean = true;

      inputs.forEach((item: Element) => {
        let price = +(<HTMLInputElement>item).value;
        if (!price) {
          (<HTMLInputElement>item).style.cssText = `
          background-color:#fae7e7;

          `;
          isValid = false;
        }
      });
      return isValid;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  isValidInputs(): boolean {
    try {
      let result = true;

      let inputElements = document.querySelectorAll(`.size-input`);
      inputElements.forEach((el) => {
        if (el?.classList.contains('input-error')) {
          result = false;
          return;
        }
      });

      return result;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  isEmptyInput(event) {
    try {
      if (!event.target.value) {
        (<HTMLInputElement>event.target).style.cssText = `
        background-color:#fae7e7;
        `;
      } else {
        (<HTMLInputElement>event.target).removeAttribute('style');
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  resetInputs() {
    try {
      const inputs: Element[] = this.getInputs();
      inputs.forEach((item: Element) => {
        // (<HTMLInputElement>item).value = '';
        this.renderer.setProperty(<HTMLInputElement>item, 'value', '');

        let price = +(<HTMLInputElement>item).value;
        if (!price) (<HTMLInputElement>item).removeAttribute('style');
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  fillColumn(smsAggregator, smsAggregatorInput, event?) {
    try {
      if (event) if (event?.key !== 'Enter' && event?.type != 'change') return;

      const value = +(smsAggregatorInput as HTMLInputElement).value;

      //get input elements and set value
      let inputs = this.getInputs();
      inputs.forEach((input) => {
        if (input.getAttribute('data-aggregator') == smsAggregator) {
          this.renderer.setProperty(
            <HTMLInputElement>input,
            'value',
            value.toString()
          );

          // (<HTMLInputElement>input).value = value.toString();
          (<HTMLInputElement>input).removeAttribute('style');
        }
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion

  //#region Api
  //create or update
  createOrUpdateApi(model: UpdateGroupPriceDetailCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .groupPriceSocialMediaDetailsUpdate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region table copyPaste

  copyTableContent() {
    try {
      const jsonText = JSON.stringify(this.getGroupPriceDetail());
      const compressed = compressToEncodedURIComponent(jsonText);
      navigator.clipboard.writeText(compressed);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  pasteTableContent() {
    navigator.clipboard
      .readText()
      .then((text) => {
        try {
          const deCompressed = decompressFromEncodedURIComponent(text);
          const model = JSON.parse(deCompressed) as GroupPriceDetailDto[];
          this.setGroupPriceDetail(model);
        } catch (error) {
          this.dialogService.openDialog({
            title: 'common.error',
            message: 'messages.contentIsInvalid',
            status: DialogStatus.error,
          });
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.systemManagement
          );
        }
      })
      .catch((error) => {
        ConsoleService.error('Failed to read clipboard contents: ', error);
      });
  }

  //#endregion

  //#region operation

  onReset() {
    this.loading = true;
    super.onReset();
    this.resetInputs();
    this.loading = false;
  }

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    try {
      //check is empty table
      if (!this.isEmptyInputs()) return;
      if (!this.isValidInputs()) return;

      this.groupPriceDetail = this.getGroupPriceDetail();

      this.model.items = this.groupPriceDetail;
      this.model.groupPriceId = this.formPageConfig.editId;
      this.createOrUpdateApi(this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#endregion

  //#region convertor

  convertMbToKb() {
    this.kiloByteValue = +(this.megaByteValue * 1024).toFixed(3);
  }

  convertKBtoMb() {
    this.megaByteValue = +(this.kiloByteValue / 1024).toFixed(3);
  }

  //#endregion

  setInfinite(beginningInput, endInput, endOfSizeRangeIndex) {
    if (this.sizeRanges[endOfSizeRangeIndex])
      this.sizeRanges[endOfSizeRangeIndex].endOfSize = '∞';
    this.addInputError(beginningInput, endInput);
    this.removeInputError(beginningInput, endInput);
  }

  addInputError(beginningInput, endInput) {
    if (
      !(beginningInput as HTMLInputElement).classList?.contains(
        'input-error'
      ) ||
      !(endInput as HTMLInputElement).classList?.contains('input-error')
    ) {
      (beginningInput as HTMLInputElement).classList?.add('input-error');
      (endInput as HTMLInputElement).classList?.add('input-error');
    }
  }

  removeInputError(beginningInput, endInput) {
    if (
      (beginningInput as HTMLInputElement).classList?.contains('input-error') ||
      !(endInput as HTMLInputElement).classList?.contains('input-error')
    ) {
      (beginningInput as HTMLInputElement).classList?.remove('input-error');
      (endInput as HTMLInputElement).classList?.remove('input-error');
    }
  }
}
